import { render, staticRenderFns } from "./CustomerParentBar.component.vue?vue&type=template&id=381b7086&scoped=true"
import script from "./CustomerParentBar.component.vue?vue&type=script&lang=js"
export * from "./CustomerParentBar.component.vue?vue&type=script&lang=js"
import style0 from "./CustomerParentBar.component.vue?vue&type=style&index=0&id=381b7086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381b7086",
  null
  
)

export default component.exports